/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { IErrorState } from '@msdyn365-commerce/components';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { IDimensionForSelectedVariant, OrderTemplateLine } from '@msdyn365-commerce-modules/retail-actions';

import { QuickOrderGridProduct } from './quick-order-grid-product';

/**
 * QuickOrderGrid state message Interface.
 */
export interface IQuickOrderGridStateMessage {
    isOpen: boolean;
    messageGlyph: string;
    messageText: string;
    statusCssString: string;
}

/**
 * QuickOrderGrid state Interface.
 */
export interface IQuickOrderGridState {
    isQuickOrderGridFormExpanded: boolean;
    isUpdatingDimension?: boolean;
    productResponse: SimpleProduct | undefined;
    productDimensions: IDimensionForSelectedVariant[] | undefined;
    min: number | undefined;
    max: number | undefined;
    quantity: number;
    stateMessage?: IQuickOrderGridStateMessage;
    topStateMessage?: IQuickOrderGridStateMessage;
    productDimensionErrorState: IErrorState;
    isMobile: boolean;
    products: OrderTemplateLine[];
    productListId: string;
}

/**
 * QuickOrder Grid Row view.
 */
export interface IQuickOrderGridRowViewModel extends OrderTemplateLine {
    isChecked: boolean;
}

/**
 * Interface for quick order callbacks.
 */
export interface IQuickOrderGridRowCallbacks {
    onRemoveItem(line: QuickOrderGridProduct): void;
    onChangeQuantity(orderTemplateLineId: string | undefined, quantity: number): boolean;
}

/**
 * Interface for quick order grid action view props.
 */
export interface IQuickOrderGridActionsViewProps {
    addProductListToBag: React.ReactNode;
    removeProductList?: React.ReactNode;
    userMessage?: React.ReactNode;
}

export const RetailDefaultOrderQuantityLimitsFeatureName: string = 'Dynamics.AX.Application.RetailDefaultOrderQuantityLimitsFeature';

export const EcommerceQuantityLimitConfigurationsFeatureName: string =
    'Dynamics.AX.Application.EcommerceQuantityLimitConfigurationsFeature';
